import React from "react";
import { Link } from "react-router-dom";
import {
  BrainBalance,
  BrainCreditsBalance,
  PepecoinBalance,
  StakedBalance,
} from "./balances";

export default function InventoryBalances() {
  return (
    <div className="d-flex row g-2 g-xxl-3">
      <div className="col-sm-6 col-lg-4 col-xxl-3">
        <div className="w-100">
          <Link
            className="btnHover2 d-flex align-items-center"
            to="https://app.uniswap.org/tokens/ethereum/0xa9e8acf069c58aec8825542845fd754e41a9489a"
          >
            <span className="d-flex flex-column align-items-center justify-content-between w-100 position-relative">
              <span className="px-4 py-c-1 d-inline-block">
                Pepecoin
                <br />
                <PepecoinBalance noImg />
              </span>
              <span className="w-100 bg-d">
                <div className="border-gradient"></div>
                <span className="p-3 d-inline-block hover-opacity">
                  Buy Pepecoin {">"}
                </span>
              </span>
            </span>
          </Link>
        </div>
      </div>
      <div className="col-sm-6 col-lg-4 col-xxl-3">
        <div className="w-100">
          <Link className="btnHover2 d-flex align-items-center" to="/staking">
            <span className="d-flex flex-column align-items-center justify-content-between w-100 position-relative">
              <span className="px-4 py-c-1 d-inline-block">
                Staked Pepecoin
                <br />
                <StakedBalance />
              </span>
              <span className="w-100 bg-d">
                <div className="border-gradient"></div>

                <span className="p-3 d-inline-block hover-opacity">
                  Stake Pepecoin {">"}
                </span>
              </span>
            </span>
          </Link>
        </div>
      </div>
      <div className="col-sm-6 col-lg-4 col-xxl-3">
        <div className="w-100">
          <Link
            className="btnHover2 d-flex align-items-center"
            to="/burning-redeem"
          >
            <span className="d-flex flex-column align-items-center justify-content-between w-100 position-relative">
              <span className="px-4 py-c-1 d-inline-block">
                Brain Credits
                <br />
                <BrainCreditsBalance />
              </span>
              <span className="w-100 bg-d">
                <div className="border-gradient"></div>
                {/* Todo change back to Mint Brains later */}
                <span className="p-3 d-inline-block hover-opacity">
                  Mint Brains {">"}
                </span>
              </span>
            </span>
          </Link>
        </div>
      </div>
      <div className="col-sm-6 col-lg-4 col-xxl-3">
        <div className="w-100">
          <Link
            className="btnHover2 d-flex align-items-center"
            to="/acquire-brain"
          >
            <span className="d-flex flex-column align-items-center justify-content-between w-100 position-relative">
              <span className="px-4 py-c-1 d-inline-block">
                Brains Owned
                <br />
                <BrainBalance />
              </span>
              <span className="w-100 bg-d">
                <div className="border-gradient"></div>

                <span className="p-3 d-inline-block hover-opacity">
                  Acquire Brains {">"}
                </span>
              </span>
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}
